import { format } from 'date-fns';
import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface OutstandingRow {
  supplier_name: string;
  invoice: string;
  invoice_date: string;
  invoice_amount: number;
  paid: number;
  outstanding: number;
  age_days: number;
}

const AGING_LABELS: Record<string, string> = {
  current: 'Current',
  '1_30': '1–30 Days',
  '31_60': '31–60 Days',
  '61_90': '61–90 Days',
  '91_180': '91–180 Days',
  over_180: 'Over 180 Days',
};

export const outstandingColumns: ReportColumn<OutstandingRow>[] = [
  { id: 'supplier_name', header: 'Supplier', accessorKey: 'supplier_name' },
  { id: 'invoice', header: 'Invoice', accessorKey: 'invoice' },
  {
    id: 'invoice_date',
    header: 'Invoice Date',
    cell: (r) => (r.invoice_date ? format(new Date(r.invoice_date), 'd MMM yyyy') : ''),
    exportValue: (r) => r.invoice_date,
  },
  {
    id: 'invoice_amount',
    header: 'Invoice Amount',
    align: 'right',
    cell: (r) => `${formatMoney(r.invoice_amount)}`,
    exportValue: (r) => r.invoice_amount,
  },
  {
    id: 'paid',
    header: 'Paid',
    align: 'right',
    cell: (r) => `${formatMoney(r.paid)}`,
    exportValue: (r) => r.paid,
  },
  {
    id: 'outstanding',
    header: 'Outstanding',
    align: 'right',
    cell: (r) => `${formatMoney(r.outstanding)}`,
    exportValue: (r) => r.outstanding,
  },
  { id: 'age_days', header: 'Age (Days)', accessorKey: 'age_days', align: 'right' },
];

export { AGING_LABELS };
